import {useDispatch, useSelector} from 'react-redux';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useDeviceName from '../../../hooks/useDeviceName';
import appErrorService from '../../../services/app/appErrorService';
import connectivityService from '../../../services/device/connectivityService';
import {setNotificationSuccess} from '../../../state/ducks/global';
import {makeSelectIsReconnectGuideEnabled} from '../../../state/selectors/global';
import useDeviceConnectionStatus from './useDeviceConnectionStatus';

const useDeviceConnectionNotification = () => {
    const isReconnectGuideEnabled = useSelector(makeSelectIsReconnectGuideEnabled());
    const deviceName = useDeviceName();
    const dispatch = useDispatch();
    const isBle = connectivityService.isBle();
    const isDisabled = !(isBle && isReconnectGuideEnabled);

    useDeviceConnectionStatus({
        onReconnect: () => {
            dispatch(
                setNotificationSuccess({
                    textKey: localizationKeys.DEVICE_RECONNECT_NOTIFICATION,
                    textFormatValues: deviceName,
                })
            );
        },
        onDisconnect: () => {
            appErrorService.showDeviceDisconnectNotification();
        },
        isDisabled,
    });
};

export default useDeviceConnectionNotification;
